module.exports = __webpack_public_path__ + "media/images/background/2d-4411a0c83d7d432a474cc721f6903b83.jpg";